<div class="container-tab-lists">
  <mat-tab-group mat-stretch-tabs="false" orientation="vertical" #tabGroup (selectedTabChange)="defaults.updateComponentTab($event.tab.textLabel)">
    <mat-tab label="Waves">
      <div class="inner-tcontainer-tab">
        <div class="panel-body row">
          <p>In order to configure a specific wave (configuring levers or assigning entities), please select a wave clicking on respective arrow.</p>
        </div>

        <wave (selectedWaveEmit)="onSelectedWave($event)"></wave>
        @if (selectedWave.WaveId !== -1) {
          <waveexcellenceleverconfig [selectedWave]="selectedWave"></waveexcellenceleverconfig>
        }
        @if (selectedWave.WaveId !== -1) {
          <assessment-assignment [selectedWave]="selectedWave"></assessment-assignment>
        }
      </div>
    </mat-tab>

    <mat-tab label="Levers">
      <div class="inner-tcontainer-tab">
        <excellence-lever></excellence-lever>
      </div>
    </mat-tab>

    <mat-tab label="Factors">
      <div class="inner-tcontainer-tab">
        <excellence-factor></excellence-factor>
      </div>
    </mat-tab>

    <mat-tab label="KPIs">
      <div class="inner-tcontainer-tab">
        <excellence-lever-kpi></excellence-lever-kpi>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>